import { configureStore } from "@reduxjs/toolkit";
import chartsReducer from "./slice/index";

export const store = configureStore({
  reducer: {
    charts: chartsReducer,
  },
});
